import { t } from 'i18next';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { CardText, Spinner } from 'reactstrap';
import { CustomAlert } from '../../components/CustomAlert/CustomAlert';
import PasswordInput from '../../components/Inputs/PasswordInput';
import LoginContext from '../../context/LoginContext/LoginContext';
import { APP_VERSION, getTenantInfoByKey, isAuthenticated } from '../../helpers/helpers';
import backgroundImgLogin from '../../assets/photo-login.png';
import ExactianLogo from '../../assets/logo-exactian.png';
import orangeArrows from '../../assets/orange-arrows.png';

const Login = () => {

    const { loginState, loginSession, cleanAlerts } = useContext(LoginContext);

    const [user, setUser] = useState({ user_name: '', password: '', app: 'ACCESS' });

    const disabled = !!!user.user_name.trim() || !!!user.password.trim();

    const navigate = useNavigate();

    const auth = isAuthenticated();

    const handleChange = (e) => {
        const { value, name } = e.target;
        setUser({
            ...user,
            [name]: value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (disabled) return
        loginSession(user)
    }

    useEffect(() => {
        if (auth) {
            navigate('/selectAccessOpening')
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className='' style={{ backgroundColor: '#FFFFFF' }}>

            <div className="login-banner position-relative">
                <img src={backgroundImgLogin} className="h-100 w-100" alt="fondo-exactian-login" />

                <div className="logo-container">
                    <img src={ExactianLogo} alt="ExactianLogo" className="exactian-logo" />
                </div>

                <div className="arrow-container d-flex align-items-center gap-2">
                    <img src={orangeArrows}
                        alt="orange-arrow"
                        className="exactian-logo"
                        style={{ width: '50px', height: '50px' }}
                    />
                    <h3 className="white-color">
                        {t('ENTRIES').toUpperCase()}
                    </h3>
                </div>
            </div>

            <div className='p-3'>

                <div className='d-flex justify-content-center'>
                    <img src={getTenantInfoByKey('image_path')} alt="" />
                </div>

                <form onSubmit={handleSubmit}>
                    {loginState.login.error ? <CustomAlert text={loginState.login.message} color={'danger'} /> : null}
                    <div>
                        <label
                            htmlFor="user_name"
                            className="form-label gray-color-500"
                        >
                            {t('USER_NAME')}
                        </label>
                        <input
                            placeholder={t('ENTER_USER_NAME')}
                            type="text"
                            name="user_name"
                            className="form-control"
                            autoComplete='off'
                            onChange={handleChange}
                            value={user.user_name}
                        />
                    </div>
                    <div className='mt-4'>
                        <label
                            htmlFor="password"
                            className="form-label gray-color-500"
                        >
                            {t('PASSWORD')}
                        </label>
                        <PasswordInput
                            name={"password"}
                            onChange={handleChange}
                            value={user.password}
                        />
                    </div>
                    {
                        loginState.login.isFetching ?
                            <div className="d-flex mt-4 justify-content-center">
                                <Spinner />
                            </div>
                            :
                            <>
                                <span
                                    type='button'
                                    onClick={() => {
                                        cleanAlerts()
                                        navigate('/recoverPassword')
                                    }}
                                    style={{ fontSize: '14px',/* color:'#9E9E9E' */ }}
                                    className='text-end mt-3 d-block'
                                >
                                    {t('RECOVER_PASSWORD')}
                                </span>

                                <button
                                    style={{ backgroundColor: '#e73f14', color: '#fff', border: 'none' }}
                                    type='submit'
                                    className={`btn w-100 mt-4`}
                                    disabled={disabled}
                                >
                                    {t('GET_INTO')}
                                </button>
                            </>
                    }
                </form>
                <CardText className="text-muted text-center mt-4">
                    <small>
                        V. {APP_VERSION} - © - Exactian Consulting S.A. -{' '}
                        <a
                            href="https://www.exactian.com"
                            className="card-link text-decoration-none new-orange-color"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.exactian.com
                        </a>
                    </small>
                </CardText>
            </div>
        </div >
    )
}

export default Login